var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgLightBulb24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.37,
    d: "m8.085 16.295.656 2.058a1.685 1.685 0 0 0 1.942 1.139l3.473-.708a1.685 1.685 0 0 0 1.25-1.085l.498-1.397a6.623 6.623 0 0 0 2.39-3.14 6.551 6.551 0 0 0 .102-4.153 6.617 6.617 0 0 0-2.417-3.394A6.73 6.73 0 0 0 12 4.315a6.731 6.731 0 0 0-3.98 1.3 6.618 6.618 0 0 0-2.417 3.394 6.552 6.552 0 0 0 .104 4.154 6.623 6.623 0 0 0 2.378 3.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 0.78,
    d: "M12.377 8.2 9.6 11.8h2.5l-.278 2.4 2.778-3.6h-2.5l.277-2.4Z"
  }))));
});
SvgLightBulb24.displayName = "SvgLightBulb24";
export default SvgLightBulb24;